<template>
  <v-app id="inspire">
    <v-main>
      <v-container v-if="!authenticated" class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-1">
              <v-toolbar :color="$vuetify.theme.dark ? 'light' : 'white'" flat>
                <v-toolbar-title> {{ $t("form.login.register") }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <a :href="'//catalogs-parts.com/'+$i18n.locale+'/'">
                  <img
                    :src="require(`@/assets/logo.png`)"
                    height="40px"
                    width="51px"
                  />
                </a>
              </v-toolbar>
              <v-expand-transition>
              </v-expand-transition>
              <v-expand-transition>
                  <register-form
                      @success="$router.push({ path: '/auth'})"
                      @cancel="$router.push({ path: '/auth'})"
                  />
              </v-expand-transition>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import LanguageSwitcher from "../components/common/LanguageSwitcher";
import RegisterForm from "@/components/RegisterForm";
export default {
  name: "Register",
  components: {RegisterForm, LanguageSwitcher },
  data: () => ({
    checkbox: false,
  }),
  mounted() {
    this.$store.dispatch("auth/check").then(() => {
      if (this.authenticated) {
        this.$router.push({ name: "Sites" });
      }
    });
  },
  computed: {
    ...mapFields("auth", ["email", "password", "authenticated", "isLoading"]),
  },
  methods: {
    login() {
      if (!this.$refs.authForm.validate() || !this.password) return;
      this.$store.dispatch("auth/login").then(() => {
        if (this.authenticated) {
          this.$router.push({ name: "Sites" });
        }
      });
    }
  },
};
</script>
